<template>
  <v-container fluid v-if="this.condition()" grid-list-lg text-xs-center>
    <v-alert
        v-if="this.$store.state.warnings.length > 0 || this.alerte != null"
        icon="mdi-alert-octagon-outline"
        type="error"
        prominent
    >
      <ul style="font-size: 14pt">
        <li
            v-for="warning in this.$store.state.warnings"
            :key="warning.msg"
            @click="scrollMeTo(warning.bloc)"
        >
          {{warning.msg}}
        </li>
      </ul>
      {{this.alerte}}
    </v-alert>
    <Header :etablissement="etablissement"></Header>

    <v-divider v-if="this.etablissement"></v-divider>

    <v-row class="ma-2 blocs">

      <BilanGratuit :etablissement="etablissement"></BilanGratuit>
      <Finance :etablissement="etablissement"></Finance>


      <v-row dense>
        <v-col><EvolutionEffectif :etablissement="etablissement"></EvolutionEffectif></v-col>
        <v-col><EtabBilansINPI :etablissement="etablissement"></EtabBilansINPI></v-col>
      </v-row>

      <Dirigeants :etablissement="etablissement"></Dirigeants>
      <Beneficiaires :etablissement="etablissement"></Beneficiaires>

      <Events :etablissement="etablissement"></Events>
      <Concurrence :etablissement="etablissement"></Concurrence>
      <Structure :etablissement="etablissement"></Structure>
      <GoogleActu :etablissement="etablissement"></GoogleActu>
      <Risque :etablissement="etablissement" :detail="true"></Risque>
      <Flotte :etablissement="etablissement" ></Flotte>
      <Orias :etablissement="etablissement"></Orias>
      <Tourisme />
      <Alimconfiance/>
      <RGE :etablissement="etablissement"></RGE>
      <Qualibat :etablissement="etablissement"></Qualibat>

      <QualifElec :etablissement="etablissement"></QualifElec>
      <ContextClients :etablissement="etablissement"></ContextClients>

    </v-row>

    <v-layout v-if="this.displaydebug" row wrap >

      <h1 >DONNES RECUES DE L'API ENTREPRISE</h1>
      <json-viewer :value="etablissement"></json-viewer>
    </v-layout>

  </v-container>

</template>

<script>
import Header from '@/components/etablissement/EtabHeader';
import Dirigeants from '@/components/etablissement/EtabDirigeants';

import Events from '@/components/etablissement/EtabEvents';
import Concurrence from "@/components/etablissement/EtabConcurrence";
import Qualibat from "@/components/etablissement/EtabQualibat";
import Finance from "@/components/etablissement/EtabFinance";
import Structure from "@/components/etablissement/EtabEnvironnement";
import BilanGratuit from "@/components/etablissement/EtabBilanGratuit";
import EvolutionEffectif from "@/components/etablissement/EtabEvolutionEffectif";
import EtabBilansINPI from '@/components/etablissement/EtabBilansINPI';
import GoogleActu from "@/components/etablissement/EtabGoogleActu";
import Risque from "@/components/etablissement/EtabSyntheseRisque";
import Flotte from "@/components/etablissement/EtabFlotte";
import Tourisme from "@/components/etablissement/EtabTourisme";
import RGE from "@/components/etablissement/EtabRGE";
import QualifElec from "@/components/etablissement/EtabQualifElec";
import Beneficiaires from  "@/components/etablissement/EtabBeneficiaires";
import ContextClients from "@/components/etablissement/EtabContexteClient";
import Alimconfiance from "@/components/etablissement/EtabAlimConfiance";
import Orias from "@/components/etablissement/EtabOrias";

export default {
  name: 'EtablissementItem',
  props: ['etablissement'],
  components: {
    Alimconfiance,
    Tourisme,
    Flotte,
    Risque,
    BilanGratuit,
    EvolutionEffectif,
    EtabBilansINPI,
    Structure,
    Concurrence,
    Header,
    Dirigeants,
    Beneficiaires,
    GoogleActu,
    Events,
    Qualibat,
    Finance,
    RGE,
    QualifElec,
    ContextClients,
    Orias
  },
  computed: {
    displaydebug() {
      var disp = process.env.VUE_APP_DEBUG_INFO || "False"
      return disp=="True"
    },
     alerte : function() {
      var defaillance = this.$store.getters.getbloc("finance", "indicateurs", "score_defaillance")

      if (defaillance && defaillance.valeur != null)
        // FIXME mise en retrait score defaillance afficher l'alerte uniqueemnt si score == 1 
        // (car ça signifie etablissement cessé ou en procédure collective)
        if ( defaillance.valeur.warning && defaillance.valeur.proba >= 1 ) { 
           return defaillance.libelle + " (50% des entreprises avec risque de défaillance élevé seront en contentieux dans les 3 ans)"
        } else {
            var score = this.$store.getters.getbloc("finance", "indicateurs", "score_credit_detail", null, "valeur")
            if (score == null) {
              score = this.$store.getters.getbloc("finance", "indicateurs", "score_credit", null, "valeur")
            }
           if (score  && score.severite==1) {
             return  score.resume
           } else {
             return null
           }
      } else {
        return null
      }
    },
  },
  methods: {
    condition() {
      return ! (this.etablissement  && Object.keys(this.etablissement).length === 0 && this.etablissement.constructor === Object)
    }
  }
};
</script>

<style lang="scss" >
  #app .v-list-item__content {
      padding: 7px 0;
  }
  #app .v-list-item {
      min-height : 0px;
  }
</style>